export default __webpack_public_path__ + "static/media/auto_elek_1019_1.7ca9194e.jpg";